import { type ReactNode } from 'react';
import { MoreVertical } from 'lucide-react';
import {
  DropdownMenu as DropdownMenuPrimitive,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { cn } from '@/lib/utils';

type DropdownMenuProps = {
  trigger?: ReactNode;
  children: ReactNode;
};

export function DropdownMenu({ trigger, children }: DropdownMenuProps) {
  return (
    <DropdownMenuPrimitive>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          onClick={(e) => e.stopPropagation()}
          className="interactive-soft rounded-full p-2 text-foreground bg-background/80 backdrop-blur-sm shadow-sm hover:bg-background/90 hover:shadow-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/40 focus-visible:ring-offset-2 focus-visible:ring-offset-background transition-all"
        >
          {trigger || <MoreVertical size={20} />}
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {children}
      </DropdownMenuContent>
    </DropdownMenuPrimitive>
  );
}

type DropdownItemProps = {
  onClick: (e: React.MouseEvent) => void;
  icon?: ReactNode;
  children: ReactNode;
  danger?: boolean;
  disabled?: boolean;
};

export function DropdownItem({ onClick, icon, children, danger, disabled }: DropdownItemProps) {
  return (
    <DropdownMenuItem
      onClick={(e) => {
        e.stopPropagation();
        if (!disabled) {
          onClick(e);
        }
      }}
      disabled={disabled}
      className={cn(
        'gap-3 px-3',
        danger && 'text-destructive focus:text-destructive focus:bg-destructive/10',
        disabled && 'cursor-not-allowed opacity-50 data-[highlighted]:translate-x-0'
      )}
    >
      {icon}
      {children}
    </DropdownMenuItem>
  );
}
